import { Chip } from '@mui/material';

const stateColors = {
  Enviado: 'primary',
  Revisado: 'info',
  'Preparando Propuesta': 'warning',
  'Pendiente Aprobación': '',
  Aprobado: 'success',
  Archivado: 'error',
  Rechazado: 'error'
};

export const StateChips = (status) => {
  const color = stateColors[status] || 'default';
  const chipStyle = {
    width: '100%',
    justifyContent: 'center'
  };
  return <Chip label={status} color={color} style={chipStyle} />;
};
